<template>
  <v-dialog
    v-model="dialog"
    width="70%"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-list-item
        v-bind="attrs"
        v-on="on">
        <h4>Log's id: {{ log.id}}, Date: {{ log.date }}</h4>
        <v-spacer/>
        <v-icon
          size="50"
          class="pb-2"
        >
          mdi-folder-open
        </v-icon>
      </v-list-item>
      <v-divider/>
    </template>
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        Log {{ log.id}}<v-spacer/> Date: {{ log.date }}
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12">
            <h3>Time taken: {{log.time_taken}}</h3>
            <br>
            <h3>Output:</h3>
            <v-textarea
              v-model="log.output"
              readonly="true"
              filled="true"
              auto-grow="true"
              label="Output"
            />
            <br>
            <v-divider/>
            <h3>Logs:</h3>
            <v-textarea
              v-model="log.log"
              readonly="true"
              filled="true"
              label="Logs"
            />
          </v-col>
        </v-row>

      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    log: {
      type: Object,
      default: null,
    },
  },
  data () {
    return {
      dialog: false,
    }
  },
  methods: {
    test() {
      this.dialog = true
    },
  }
}
</script>

<style scoped>

</style>
